import { Slider } from '@listening/frontend/components/radix/slider';
import { useEffect, useState } from 'react';
import { Zenitho } from 'uvcanvas';
import { ZenithoFallback } from '@/components/shared-ui/zenitho-fallback';

export function ProgressIndicator() {
  const [scrollPercent, setScrollPercent] = useState(0);

  useEffect(() => {
    const calculateScrollPercentage = () => {
      const scrollableHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const currentScroll = window.scrollY;
      const scrollPercentage = (currentScroll / scrollableHeight) * 100;
      setScrollPercent(scrollPercentage);
    };

    window.addEventListener('scroll', calculateScrollPercentage);
    return () => {
      window.removeEventListener('scroll', calculateScrollPercentage);
    };
  }, []);

  return (
    <Slider
      className='h-[6px] w-full'
      defaultValue={[0]}
      disabled
      max={100}
      min={0}
      rangeClassName='rounded-full transition-all duration-300'
      rangeComponent={<Zenitho fallback={<ZenithoFallback />} />}
      thumbClassName={null} // TODO: Make it so I can swap colors. https://github.com/latentcat/uvcanvas/issues/4#issuecomment-1977769672
      value={[scrollPercent]}
    />
  );
}
